import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import { useLanguage } from '../contexts/LanguageContext';

export default function LanguageSelector() {
    const { selectedCountry, changeLanguage, getCurrentLanguageName } = useLanguage();

    const countries = [
        { name: 'English', code: 'US' },
        { name: 'Türkçe', code: 'TR' },
        { name: 'Deutsch', code: 'DE' },
        { name: 'Français', code: 'FR' },
        { name: 'Italiano', code: 'IT' },
        { name: 'Română', code: 'RO' }
    ];

    // Context'ten gelen selectedCountry'nin code'una göre countries array'inden eşleşen elemanı bul
    const selectedValue = useMemo(() => {
        if (!selectedCountry?.code) return null;
        return countries.find(c => c.code === selectedCountry.code) || null;
    }, [selectedCountry]);

    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <i 
                        className={`fi fi-${option.code.toLowerCase()}`}
                        style={{ fontSize: '1.5em' }}
                        title={option.name}
                    />
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center p-2">
                <i className={`fi fi-${option.code.toLowerCase()} mr-2`} style={{ fontSize: '1.2em' }} />
                <div>{option.name}</div>
            </div>
        );
    };

    // Inline styles
    const containerStyle = {
        display: 'flex',
        alignItems: 'center'
    };

    const dropdownStyle = {
        minWidth: 'auto',
        width: 'auto',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent'
    };

    return (
        <div style={containerStyle} className="language-selector-container">
            <Dropdown
                value={selectedValue}
                onChange={(e) => changeLanguage(e.value)}
                options={countries}
                optionLabel="name"
                size="small"
                placeholder="Select Language"
                showClear={false}
                dropdownIcon="pi pi-chevron-down"
                valueTemplate={selectedCountryTemplate}
                itemTemplate={countryOptionTemplate}
                className="language-selector p-0 border-none"
                panelClassName="language-panel"
                style={dropdownStyle}
                tooltip={`Current: ${getCurrentLanguageName()}`}
                tooltipOptions={{ position: 'bottom' }}
            />
            <Tooltip target=".flag-container i" position="bottom" />
            
            {/* Custom CSS */}
            <style>
                {`
                .language-selector .p-dropdown-trigger {
                    width: 20px !important;
                    display: flex !important;
                    align-items: center;
                    justify-content: center;
                }
                .language-selector .p-dropdown-trigger .pi-chevron-down {
                    font-size: 0.8em;
                }
                .language-panel .p-dropdown-item {
                    padding: 0.5rem 0.75rem;
                }
                .flag-container i {
                    height: auto !important;
                    width: auto !important;
                }
                `}
            </style>
        </div>
    );
}
